module.exports = __webpack_public_path__ + "img/grandfather.657e10fb.png";